import orangeArrow from "../../images/slider-arrow.png";
import greenArrow from "../../images/slider-arrow-green.png";

export default theme => ({
    footer: {
        position: 'relative',
        backgroundColor: theme.palette.secondary.main,
        padding: 12,
        paddingBottom: 100,
        width: '100vw',
        left: '50%',
        transform: 'translateX(-50vw)',
        [theme.breakpoints.up('md')]: {
            padding: '12px 28px',
        },
        '& .back-to-top': {
            color: '#72ce9b',
            position: 'relative',
            float: 'right',
            width: 'auto',
            padding: 0,
            margin: 0,
            letterSpacing: '0.04em',
            fontSize: 18,
            textTransform: 'uppercase',
            fontFamily: theme.headerFont,
            paddingLeft: 5,
            '&::after': {
                width: 14,
                height: 14,
                content: '""',
                display: 'inline-block',
                backgroundImage: 'url(' + greenArrow + ')',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                marginLeft: 10,
                transform: 'rotate(-90deg)',
            }
        },
        '& .site-logo': {
            textAlign: 'center',
            position: 'relative',
            [theme.breakpoints.up('md')]: {
                textAlign: 'left',
            },
            '& img': {
                display: 'block',
                width: 136,
                margin: '0 auto 100px',
                [theme.breakpoints.up('lg')]: {
                    margin: 0,
                }
            }
        },
        '& .footer-h': {
            color: theme.palette.primary.main,
            padding: '10px 0',
            position: 'relative',
            fontFamily: theme.headerFont,
            fontSize: 20,
            letterSpacing: '0.06em',
            lineHeight: 1,
            margin: '0 0 10px',
            textTransform: 'uppercase',
            backgroundColor: theme.palette.secondary.main,
            borderBottom: '2px solid',
            borderColor: theme.palette.primary.main,
            '&::after': {
                width: 14,
                height: 14,
                content: '""',
                display: 'inline-block',
                backgroundImage: 'url(' + orangeArrow + ')',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                marginLeft: 10,
                transform: 'rotate(90deg)',
                float: 'right',
            },
            '&[data-open="true"]': {
                '&::after': {
                    transform: 'rotate(-90deg)',
                }
            },
            [theme.breakpoints.up('md')]: {
                color: theme.palette.common.white,
                borderBottom: 'none',
                '&::after': {
                    display: 'none',
                }
            }
        },
        '& .footer-expand': {
            display: 'none',
            '&[data-open="true"]': {
                display: 'block',
            },
            [theme.breakpoints.up('md')]: {
                display: 'block !important',
            }
        },
        '& a, & button': {
            display: 'block',
            color: theme.palette.primary.main,
            position: 'relative',
            letterSpacing: '0.018em',
            lineHeight: 3.2,
            fontSize: 14,
            textDecoration: 'none',
            transition: 'color .3s ease-in-out',
            '&:hover, &:focus': {
                color: theme.palette.primary.dark,
            },
        },
        '& button': {
            background: 'none',
            border: 0,
            padding: 0,
            fontFamily: 'inherit'
        },
        '& .social-links': {
            '& a': {
                textDecoration: 'none',
                transition: 'color .3s ease-in-out',
                '&:hover, &:focus': {
                    color: theme.palette.primary.dark,
                    '& svg': {
                        color: theme.palette.primary.dark,
                    },
                },
                '& svg': {
                    width: 24,
                    height: 24,
                    marginRight: 12,
                    verticalAlign: 'middle',
                    color: theme.palette.secondary.contrastText,
                },
            }
        },
        '& .drink-aware': {
            borderTop: '2px solid',
            borderColor: theme.palette.common.white,
            marginTop: 100,
            paddingTop: 50,
            '& img': {
                display: 'block',
                margin: '0 auto',
                width: 220,
            },
            [theme.breakpoints.up('md')]: {
                borderColor: 'rgba(255,255,255,0.1)',
                marginTop: 200,
                paddingTop: 24,
                paddingBottom: 40,
                '& img': {
                    opacity: '0.3',
                    margin: 0,
                },
            }
        },
        '& .credits': {
            '& p': {
                color: theme.palette.common.white,
                textTransform: 'uppercase',
                textAlign: 'center',
                fontSize: 14,
                letterSpacing: '0.032em',
                lineHeight: 1.8,
                margin: 0,
                '& span': {
                    display: 'block',
                }
            },
            [theme.breakpoints.up('md')]: {
                borderTop: '2px solid',
                borderColor: 'rgba(255,255,255,0.1)',
                marginTop: 200,
                paddingTop: 24,
                paddingBottom: 40,
                '& p': {
                    opacity: '0.3',
                    textAlign: 'right',
                    display: 'block',
                    '& > span': {
                        display: 'inline-block !important',
                    }
                }
            },
        }
    },
    footerTheme: {
        ...theme.footerTheme,
    }
})